import "./App.css";
import PathFindVisu from "./pfv/PathFindVisu";

function App() {
  return (
    <div className="App">
      <PathFindVisu />
    </div>
  );
}

export default App;
